var map = {
	"./0.png": "./src/assets/icons/0.png",
	"./10.png": "./src/assets/icons/10.png",
	"./15.png": "./src/assets/icons/15.png",
	"./5.png": "./src/assets/icons/5.png",
	"./StempelkartenIcon.png": "./src/assets/icons/StempelkartenIcon.png",
	"./ayurveda.png": "./src/assets/icons/ayurveda.png",
	"./bio.png": "./src/assets/icons/bio.png",
	"./discount-red.png": "./src/assets/icons/discount-red.png",
	"./gutschein.png": "./src/assets/icons/gutschein.png",
	"./halal.png": "./src/assets/icons/halal.png",
	"./info.png": "./src/assets/icons/info.png",
	"./item-minus.png": "./src/assets/icons/item-minus.png",
	"./item-plus.png": "./src/assets/icons/item-plus.png",
	"./koscher.png": "./src/assets/icons/koscher.png",
	"./powered_by_stripe.png": "./src/assets/icons/powered_by_stripe.png",
	"./service.png": "./src/assets/icons/service.png",
	"./vegan-140.png": "./src/assets/icons/vegan-140.png",
	"./vegi.png": "./src/assets/icons/vegi.png",
	"./waiter.png": "./src/assets/icons/waiter.png",
	"./wheat.png": "./src/assets/icons/wheat.png",
	"./wollknaul.png": "./src/assets/icons/wollknaul.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*\\.png$";